
import { useThrowIfPropHasChanged } from '../../../../../../Hooks/useThrowIfPropHasChanged';
import { IClientBusinessModel } from '../../../../../../Types/ClientModelTypes';
import {
  IFunctionMenuItem,
  useItemFunctionMenuItemsType,
} from '../../../../../../Utils/ObjektVyUtils';
import { ICollectionDataType } from '../../BusinessCollectionComponents/Queries/BusinessCollectionQuery';
import { useDefaultFunctionMenu } from '../DefaultFunctionMenu/useDefaultFunctionMenu';

interface IProps {
  children: (items: IFunctionMenuItem[]) => React.ReactElement<any>;
  id: string;
  item: ICollectionDataType;
  collection: IClientBusinessModel;
  associationName?: string;
  useFunktionsMenyItems?: useItemFunctionMenuItemsType;
  hideDefaultFunktionsMenyItems?: boolean;
}

const FunctionMenuItemsRenderProp: React.FC<IProps> = (props: IProps) => {
  useThrowIfPropHasChanged(
    'Hook useFunktionsMenyItems',
    props.useFunktionsMenyItems
  );

  let defaultFuntionMenyItems = useDefaultFunctionMenu({
    id: props.id,
    collection: props.collection,
    associationName: props.associationName,
    item: props.item,
  });

  if (props.hideDefaultFunktionsMenyItems) {
    defaultFuntionMenyItems = [];
  }

  const funktionsMenyItems = props.useFunktionsMenyItems
    ? [
        ...defaultFuntionMenyItems,
        ...props.useFunktionsMenyItems({
          id: props.id,
          collection: props.collection,
          associationName: props.associationName,
          item: props.item,
        }),
      ]
    : defaultFuntionMenyItems;
  const visibleFunctionMenyItems = funktionsMenyItems.filter(
    item => !item.hidden
  );
  return props.children(visibleFunctionMenyItems);
};

export default FunctionMenuItemsRenderProp;
